import { Grid } from "@mui/material";

import TransparentFragment from "../../../../helper-components/misc/TransparentFragment";

export default function ConfirmExamination({ title = "Save data and continue?" }) {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <TransparentFragment title={title} center p={8} />
            </Grid>
        </Grid>
    );
}
